/* eslint-disable no-dupe-keys */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "universal-cookie";
import GetProxy from "../../../common/GetProxy";
import { handleResponseCode } from "../../../../app/utilities/helpers";
const proxy = GetProxy();
const cookies = new Cookies();

export const securityHubList = createAsyncThunk(
  "post/securityHubList",
  async (props) => {
    try {
    const { pageNumber, itemsPerPage, payload } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const response = await fetch(
      `${proxy}/api/v1/aws/getFixedSecurityHubListBySearchWithStatus/list/${pageNumber}/${itemsPerPage}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
    handleResponseCode(response);
    const data = response.json();
    return response.ok ? data : Promise.reject(data);
  }catch (error){
    console.log("Error in getting data : ", error);
    throw error;
  }
  }
);
export const securityHubCurrentList = createAsyncThunk(
  "post/securityHubCurrentList",
  async (props) => {
    try {
    const { pageNumber, itemsPerPage, payload } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const res = await fetch(
      `${proxy}/api/v1/aws/getSecurityHubListBySearchWithStatus/list/${pageNumber}/${itemsPerPage}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
    handleResponseCode(res);
    const data = res.json();
    return res.ok ? data : Promise.reject(data);
  } catch(error) {
    console.log('Error', error);
    throw(error)
  }
});
export const SecurityHubCurrentListCount = createAsyncThunk(
  "post/securityHubCurrentListCount",
  async (props) => {
    try{
    const { pageNumber, itemsPerPage, payload } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const res = await fetch(
      `${proxy}/api/v1/aws/getSecurityHubListBySearchBasedOnCount`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
    handleResponseCode(res);
    const data = res.json();
    return res.ok ? data : Promise.reject(data);
  } catch(error) {
    console.log("Error", error);
    throw(error);
  }
  }
);
export const SecurityHubDrilldownList = createAsyncThunk(
  "post/SecurityHubDrilldownList",
  async (props) => {
    try {
    const { pageNumber, itemsPerPage, payload } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const res = await fetch(
      `${proxy}/api/v1/aws/getSecurityHubListBySearchWithStatus/list/${pageNumber}/${itemsPerPage}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
    handleResponseCode(res);
    const data = res.json();
    return res.ok ? data : Promise.reject(data);
  } catch(error) {
    console.log('Error', error);
    throw(error)
  }
});
export const SecurityHubDrilldownListCount = createAsyncThunk(
  "post/SecurityHubDrilldownListCount",
  async (props) => {
    try{
    const { pageNumber, itemsPerPage, payload } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const res = await fetch(
      `${proxy}/api/v1/aws/getSecurityHubListBySearchBasedOnCount`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
    handleResponseCode(res);
    const data = res.json();
    return res.ok ? data : Promise.reject(data);
  } catch(error) {
    console.log("Error", error);
    throw(error);
  }
  }
);

export const targetDateDrilldownList = createAsyncThunk(
  "post/targetDateDrilldownList",
  async (props) => {
    try {
    const { pageNumber, itemsPerPage, payload } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const res = await fetch(
      `${proxy}/api/v1/aws/getMissedTargetDateDetailsList/${pageNumber}/${itemsPerPage}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
    handleResponseCode(res);
    const data = res.json();
    return res.ok ? data : Promise.reject(data);
  } catch(error) {
    console.log('Error', error);
    throw(error)
  }
});
export const targetDateDrilldownListCount = createAsyncThunk(
  "post/targetDateDrilldownListCount",
  async (props) => {
    try{
    const { pageNumber, itemsPerPage, payload } = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const res = await fetch(
      `${proxy}/api/v1/aws/getMissedTargetDateDetailsListCount`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
    handleResponseCode(res);
    const data = res.json();
    return res.ok ? data : Promise.reject(data);
  } catch(error) {
    console.log("Error", error);
    throw(error);
  }
  }
);
export const securityHubCount = createAsyncThunk(
  "post/securityHubCount",
  async (props) => {
    try {
    const {payload} = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const res = await fetch(
      `${proxy}/api/v1/aws/getFixedSecurityHubListBySearchBasedOnCount`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
    handleResponseCode(res);
    const data = res.json();
    return res.ok ? data : Promise.reject(data);
  } catch (error) {
    console.log("Error in getting data :", error);
    throw(error)
  }
  }
);
export const securityHubNonComplianceByaccountIdAPI = createAsyncThunk(
  "post/securityHubNonComplianceByaccountId",
  async (props) => {
    try {
    const {payload}  = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const response = await fetch(
      `${proxy}/api/v1/aws/getFailedCount`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
    handleResponseCode(response);
    const data = response.json();
    return response.ok ? data : Promise.reject(data)
  } catch (error) {
    console.log(`Error : ${error}`);
  }
}
);
export const securityHubNonComplianceByTypeAPI = createAsyncThunk(
  "post/securityHubNonComplianceByType",
  async (props) => {
    try {
    const {payload}  = props;
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    const response = await fetch(
      `${proxy}/api/v1/aws/getNonCompliantByResourceWiseCount`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      }
    )
    handleResponseCode(response);
      const data = response.json();
      return response.ok  ? data : Promise.reject(data);
  } catch(error){
    console.log("Error in getting data", error);
  }
  }
);
export const getSHFTargetMissedItems = createAsyncThunk(
  "post/getSHFTargetMissedItems",
  async (props) => {
    try {
      const { payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(`${proxy}/api/v1/aws/getTargetDates`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const getSHFTargetDueTrend = createAsyncThunk(
  "post/getSHFTargetDueTrend",
  async (props) => {
    try {
      const { payload } = props;    
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(`${proxy}/api/v1/aws/getSixMonthTargetDate`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const getSHFOpenFindings = createAsyncThunk(
  "post/getOpenFindingsCount",
  async (props) => {
    try {
      const { payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(`${proxy}/api/v1/aws/getOpenFindingsCount`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const getSHFClosedFindings = createAsyncThunk(
  "post/getClosedFindingsCount",
  async (props) => {
    try {
      const { payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(`${proxy}/api/v1/aws/getClosedFindingsCount`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "CMTS-API-TOKEN": Apitoken,
          USERNAME: User,
        },
        body: JSON.stringify(payload),
      });
      handleResponseCode(response);
      const data = response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);
export const FindingsDistribution = createAsyncThunk(
  "post/FindingsDistribution",
  async (props) => {
    try {
      const { payload } = props;
      const Apitoken = cookies.get("apitoken");
      const User = cookies.get("username");
      const response = await fetch(
        `${proxy}/api/v1/aws/findingsDistribution`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "CMTS-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

const  initialState = {
  securityHubListFixed: [],
  securityHubCurrentList: [],
  securityHubCurrentCount : [],
  securityHubDrilldownList: [],
  targetDateDrilldownListData: [],
  securityHubDrilldownCount : [],
  targetDateDrilldownCount : [],
  securityHubCount:[],  
  tableLoading: false,
  CurentShTableListLoading: false,
  CurentShTableCountLoading: false,
  DrilldowntableLoading: false,
  DrilldownShTableLoading: false,
  targetDateDrilldownLoading: false,
  targetDateSHDrilldownLoading: false,
  error: '',
  nonComplianceById:[],
  nonComplianceByIdLoading:false,
  nonComplianceByType:[],
  nonComplianceByTypeLoading:false,  
  securityHubTargetMissedItems:[],
  securityHubTargetMissedItemsLoading:false,
  securityHubTargetDueTrend:[],
  securityHubTargetDueTrendLoading:false,
  securityHubOpenFindings:[],
  securityHubOpenFindingsLoading:false,
  securityHubClosedFindings:[],
  securityHubClosedFindingsLoading:false,
  DistributionChart:[],
  FindingDistributionloading:false,
  apierror : false,
}
export const SecurityHubSlice = createSlice({
  name: "shfSlice",
  initialState,
  reducers: {
    resetSecurityHubData: () => {
      return initialState;
     },
     setError: {
      reducer(state, action) {
        state.apierror = false;
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(securityHubList.pending, (state, action) => {
        state.tableLoading = true;
        state.error = "";
        state.apierror = false;
      })
      .addCase(securityHubList.fulfilled, (state, action) => {
        state.tableLoading = false;
        state.securityHubListFixed = action.payload;
        state.apierror = false;
      })
      .addCase(securityHubList.rejected, (state, action) => {
        state.tableLoading = false;
        state.securityHubListFixed = [];
        state.error = "something went wrong"
        state.apierror = true;
      })
      .addCase(securityHubCount.pending, (state, action) => {
        state.tableLoading = true;
        state.error = "";
        state.apierror = false;
      })
      .addCase(securityHubCount.fulfilled, (state, action) => {
        state.tableLoading = false;
        state.securityHubCount = action.payload;
        state.apierror = false;
      })
      .addCase(securityHubCount.rejected, (state, action) => {
        state.tableLoading = false;
        state.apierror = true;
      })
      .addCase(securityHubCurrentList.pending, (state, action) => {
        state.CurentShTableListLoading = true;
        state.error = "";
        state.apierror = false;
      })
      .addCase(securityHubCurrentList.fulfilled, (state, action) => {
        state.CurentShTableListLoading = false;
        state.securityHubCurrentList = action.payload.content;
        state.securityHubCurrentCount = action.payload.totalElements;
        state.apierror = false;
      })
      .addCase(securityHubCurrentList.rejected, (state, action) => {
        state.CurentShTableListLoading = false;
        state.securityHubCurrentList =[];
        state.error = "Something went wrong"
        state.apierror = true;
      })

      .addCase(SecurityHubCurrentListCount.pending, (state, action) => {
        // state.CurentShTableCountLoading = true;
        state.error = "";
        state.apierror = false;
      })
      .addCase(SecurityHubCurrentListCount.fulfilled, (state, action) => {
        state.CurentShTableCountLoading = false;
        state.apierror = false;
      })
      .addCase(SecurityHubCurrentListCount.rejected, (state, action) => {
        state.CurentShTableCountLoading = false;
        state.securityHubCurrentCount = [];
        state.error = "Something went wrong"
        state.apierror = true;
      })
      .addCase(SecurityHubDrilldownList.pending, (state, action) => {
        state.DrilldowntableLoading = true;
        state.error = "";
        state.apierror = false;
      })
      .addCase(SecurityHubDrilldownList.fulfilled, (state, action) => {
        state.DrilldowntableLoading = false;
        state.securityHubDrilldownList = action.payload.content;
        state.securityHubDrilldownCount = action.payload.totalElements;
        state.apierror = false;
      })
      .addCase(SecurityHubDrilldownList.rejected, (state, action) => {
        state.DrilldowntableLoading = false;
        state.securityHubDrilldownList =[];
        state.securityHubDrilldownCount = [];
        state.error = "Something went wrong"
        state.apierror = true;
      })

      .addCase(SecurityHubDrilldownListCount.pending, (state, action) => {
        // state.DrilldownShTableLoading = true;
        state.error = "";
        state.apierror = false;
      })
      .addCase(SecurityHubDrilldownListCount.fulfilled, (state, action) => {
        // state.DrilldownShTableLoading = false;
        state.apierror = false;
      })
      .addCase(SecurityHubDrilldownListCount.rejected, (state, action) => {
        // state.DrilldownShTableLoading = false;
        state.error = "Something went wrong"
        state.apierror = true;
      })

      .addCase(targetDateDrilldownList.pending, (state, action) => {
        state.targetDateSHDrilldownLoading = true;
        state.error = "";
        state.apierror = false;
      })
      .addCase(targetDateDrilldownList.fulfilled, (state, action) => {
        state.targetDateSHDrilldownLoading = false;
        state.targetDateDrilldownListData = action.payload;
        state.apierror = false;
      })
      .addCase(targetDateDrilldownList.rejected, (state, action) => {
        state.targetDateSHDrilldownLoading = false;
        state.targetDateDrilldownListData =[];
        state.error = "Something went wrong"
        state.apierror = true;
      })

      .addCase(targetDateDrilldownListCount.pending, (state, action) => {
        state.targetDateDrilldownLoading = true;
        state.error = "";
        state.apierror = false;
      })
      .addCase(targetDateDrilldownListCount.fulfilled, (state, action) => {
        state.targetDateDrilldownLoading = false;
        state.targetDateDrilldownCount = action.payload;
        state.apierror = false;
      })
      .addCase(targetDateDrilldownListCount.rejected, (state, action) => {
        state.targetDateDrilldownLoading = false;
        state.targetDateDrilldownCount = [];
        state.error = "Something went wrong"
        state.apierror = true;
      })

      .addCase(securityHubNonComplianceByaccountIdAPI.pending, (state, action) => {
        state.nonComplianceByIdLoading = true;
        state.apierror = false;
      })
      .addCase(securityHubNonComplianceByaccountIdAPI.fulfilled, (state, action) => {
        if (action.payload.status === 500) {
          state.nonComplianceById = [];
          state.nonComplianceByIdLoading = false;
        } else {
          state.nonComplianceByIdLoading = false;
          state.nonComplianceById = action.payload;
        }
        state.apierror = false;
      })
      
      .addCase(securityHubNonComplianceByaccountIdAPI.rejected, (state, action) => {
        state.nonComplianceByIdLoading = false;
        state.nonComplianceById = [];
        state.apierror = true;
      })

      .addCase(securityHubNonComplianceByTypeAPI.pending, (state, action) => {
        state.nonComplianceByTypeLoading = true;
        state.apierror = false;
      })
      .addCase(securityHubNonComplianceByTypeAPI.fulfilled, (state, action) => {
        if (action.payload.status === 500) {
          state.nonComplianceByType = [];
          state.nonComplianceByTypeLoading = false;
        } else {
          state.nonComplianceByTypeLoading = false;
          state.nonComplianceByType = action.payload;
        }
        state.apierror = false;
      })
      
      .addCase(securityHubNonComplianceByTypeAPI.rejected, (state, action) => {
        state.nonComplianceByTypeLoading = false;
        state.nonComplianceByType = [];
        state.apierror = true;
      })


      .addCase(getSHFTargetMissedItems.pending, (state, action) => {
        state.securityHubTargetMissedItemsLoading = true;
        state.apierror = false;
      })
      .addCase(getSHFTargetMissedItems.fulfilled, (state, action) => {
          state.securityHubTargetMissedItems = action.payload;
          state.securityHubTargetMissedItemsLoading = false;
          state.apierror = false;       
      })    
      .addCase(getSHFTargetMissedItems.rejected, (state, action) => {
        state.securityHubTargetMissedItemsLoading = false;
        state.securityHubTargetMissedItems = [];
        state.apierror = true;
      })

      .addCase(getSHFTargetDueTrend.pending, (state, action) => {
        state.securityHubTargetDueTrendLoading = true;
        state.apierror = false;
      })
      .addCase(getSHFTargetDueTrend.fulfilled, (state, action) => {
        state.securityHubTargetDueTrend=action.payload;
        state.securityHubTargetDueTrendLoading=false;    
        state.apierror = false;
      })    
      .addCase(getSHFTargetDueTrend.rejected, (state, action) => {
          state.securityHubTargetDueTrend=[];
          state.securityHubTargetDueTrendLoading=false;
          state.apierror = true;
      })

      .addCase(getSHFOpenFindings.pending, (state, action) => {
        state.securityHubOpenFindingsLoading = true;
        state.apierror = false;
      })
      .addCase(getSHFOpenFindings.fulfilled, (state, action) => {
        state.securityHubOpenFindings=action.payload;
        state.securityHubOpenFindingsLoading=false;   
        state.apierror = false; 
      })    
      .addCase(getSHFOpenFindings.rejected, (state, action) => {
          state.securityHubOpenFindings=[];
          state.securityHubOpenFindingsLoading=false;
          state.apierror = true;
      })

      .addCase(getSHFClosedFindings.pending, (state, action) => {
        state.securityHubClosedFindingsLoading = true;
        state.apierror = false;
      })
      .addCase(getSHFClosedFindings.fulfilled, (state, action) => {
        state.securityHubClosedFindings=action.payload;
        state.securityHubClosedFindingsLoading=false;  
        state.apierror = false;  
      })    
      .addCase(getSHFClosedFindings.rejected, (state, action) => {
          state.securityHubClosedFindings=[];
          state.securityHubClosedFindingsLoading=false;
          state.apierror = true;
      })

      .addCase(FindingsDistribution.pending, (state, action) => {
        state.FindingDistributionloading = true;
        state.apierror = false;
      })
      .addCase(FindingsDistribution.fulfilled, (state, action) => {
        state.DistributionChart = action.payload;
        state.FindingDistributionloading = false;
        state.apierror = false;
      })
      .addCase(FindingsDistribution.rejected, (state, action) => {
        state.FindingDistributionloading = false;
        state.apierror = true;
      })

  },
});
export const {resetSecurityHubData, setError} = SecurityHubSlice.actions;
export default SecurityHubSlice.reducer;
